function initMobileMenu(){
    //Mobi menu
    $('body .hamburger').on('click',function () {
        $('body').toggleClass('mobi-menu-open')
        $(this).toggleClass('is-active');
        $.scrollLock();
        var maxMenuHeight = parseInt($(window).height() - $('.main-header').innerHeight()) + 1;
        $('nav.main .main-navbar').css('max-height',maxMenuHeight);
    });
}